// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"608":"5cb2f1459e790fc5","759":"5952fb364f363a61"}[chunkId] + ".css";
};